<template>
    <AuthFullLayout>
        <div>
            <h1 class="mb-16 text-6xl font-bold text-center">Welcome to Treeline</h1>

            <div class="pb-20 text-center"><app-button @click="handleProceed" class="!py-4 !px-8 font-bold">Proceed</app-button></div>
        </div>
    </AuthFullLayout>
</template>

<script>
import AuthFullLayout from '@/Layouts/AuthFull'
import AppButton from '@/Components/Button.vue'
import { defineComponent } from "vue";
import useForm from '@/form'

export default defineComponent({
    components: {
        AuthFullLayout,
        AppButton
    },
    setup(){
        const form = useForm()

        function handleProceed(){
            window.location.href = route('tos');
        }

        return {
            handleProceed
        }
    }
})
</script>
